import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph, Tag } from '@digdir/designsystemet-react';
import type { WorkEnvironmentEvaluation } from '../../../api/workEnvironmentTypes';
import { monthAndYear } from '../evaluationView';
import { LEVEL_COLORS } from '../riskView';
import process from '../WorkEnvironmentSurveyProcess.module.css';
import classes from './Evaluation.module.css';

/** The focus of the plans, and that every area is measured again */
export const CompareCard = ({
  data,
}: {
  data: WorkEnvironmentEvaluation;
}): ReactElement => {
  const { t, i18n } = useTranslation();
  return (
    <section
      aria-labelledby="evaluation-compare-heading"
      className={process.card}
    >
      <div className={process.cardBody}>
        <Heading level={2} data-size="sm" id="evaluation-compare-heading">
          {t('workEnvironmentEvaluation.compare.title')}
        </Heading>
        {data.focus.map((focus) => (
          <div key={focus.key} className={classes.focus}>
            <div className={classes.focusTitle}>
              <Heading level={3} data-size="2xs">
                {focus.name}
              </Heading>
              {focus.level && (
                <Tag data-color={LEVEL_COLORS[focus.level]} data-size="sm">
                  {t('workEnvironmentEvaluation.compare.before', {
                    level: t(
                      `workEnvironmentRisk.matrix.levels.${focus.level}`,
                    ),
                  })}
                </Tag>
              )}
            </div>
            {focus.goal && (
              <Paragraph data-size="sm">
                {t('workEnvironmentEvaluation.compare.goal', {
                  goal: focus.goal,
                })}
              </Paragraph>
            )}
          </div>
        ))}
        <Paragraph data-size="sm">
          {t('workEnvironmentEvaluation.compare.all', {
            count: data.baseline.areas,
          })}
        </Paragraph>
        <Paragraph data-size="sm" className={process.subtle}>
          {t('workEnvironmentEvaluation.compare.when', {
            month: monthAndYear(data.baseline.createdAt, i18n.language),
          })}
        </Paragraph>
      </div>
    </section>
  );
};
